export default {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal',
};
